export default __webpack_public_path__ + "static/media/image-activity-card-purple-background.0d96ce15.svg";